import { Operator, QueryType } from 'dashboard/models/graph-query';
import { GraphQueryTemplate } from 'dashboard/models/graph-query-template';

export const getRunnableGraphQueryTemplates = (
  gqts: GraphQueryTemplate[],
): GraphQueryTemplate[] => {
  return gqts
    .map((gqt) => {
      // allow gqts without variables
      if (hasNoVariables(gqt)) {
        return gqt;
      }
      // we allow n_hops query templates if they are n_hop queries of an account variable
      if (isNHopWithOneAccountVariable(gqt)) {
        return gqt;
      }
      return null;
    })
    .filter(Boolean) as GraphQueryTemplate[];
};

export const isNHopWithOneAccountVariable = (gqt: GraphQueryTemplate) => {
  if (gqt.attributes.type !== QueryType.NHopsFromAccount) {
    return false;
  }

  // check that it has an account conditional that is a variable
  return (
    gqt.attributes.payload.conditionals.filter((conditional) => {
      return (
        conditional.left === 'account' &&
        conditional.operator === Operator.Equals &&
        conditional.right[0].variable
      );
    }).length === 1
  );
};

// NOTE: You CANNOT simply check if gqt.payload.variables.size === 0 as I don't think
// the GQT editor updates it. Will have to do a deeper dive into this, but for now, we have to
// check the conditionals directly
export const hasNoVariables = (gqt: GraphQueryTemplate) => {
  return (
    gqt.attributes.payload.conditionals.filter((conditional) => {
      // Safe to assume [DateValue, DateValue] does not contain variables
      return !Array.isArray(conditional.right[0]) && conditional.right[0]?.variable;
    }).length === 0
  );
};
